@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.section {
	margin-top: Constants.$val-spacing-l;
	margin-bottom: Constants.$val-spacing-l;
	margin-left: Constants.$val-spacing-l;
	margin-right: Constants.$val-spacing-l;

	&__title {
		text-transform: uppercase;
		color: Colors.$col-design-gray5;
		font-size: Constants.$val-fontSizeBig;
		margin-bottom: Constants.$val-spacing-l;
	}
}